import React, { Component } from 'react'
import { BackTop, Layout, Button } from 'antd'
import { enquireScreen, unenquireScreen } from 'enquire-js'
import { ContainerQuery } from 'react-container-query'
import classNames from 'classnames'
import { Switch, Route, Redirect } from 'react-router-dom';

import AppMenu from 'components/LayoutComponents/Menu'
import AppContent from 'components/LayoutComponents/Content'
import LayoutState from 'components/LayoutComponents/LayoutState'
import OverviewPage from 'containers/OverviewPage'
import LoginPage from 'containers/LoginPage'
import ProtectedRoute from 'containers/ProtectedRoute'
import FooterContent from 'components/LayoutComponents/FooterContent'
import auth from 'utils/auth'

const Content = Layout.Content
const Header = Layout.Header
const Footer = Layout.Footer

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
}

let isMobile
enquireScreen(b => {
  isMobile = b
})

let contentBuffer = {
  pathName: null,
  content: null,
}



class App extends Component {

  state = {
    isMobile
  }

  componentDidMount() {
    this.enquireHandler = enquireScreen(mobile => {
      this.setState({
        isMobile: mobile,
      })
    })
  }

  componentWillUnmount() {
    unenquireScreen(this.enquireHandler)
  }


  render() {
    const isMobile = !!this.state.isMobile
    return (
      <ContainerQuery query={query}>
        {params => (
          <div className={classNames(params)}>

            <Layout>
              <LayoutState />

              <Layout>
                <AppMenu isMobile={isMobile} />
                <Content style={{ height: '100%'}}>
                  <Switch>
                    <ProtectedRoute exact path="/" component={OverviewPage} />
                    <Route exact path="/login" component={LoginPage} />
                    <Route exact path="/logout" render={() => {
                      auth.clearAppStorage()
                      return <Redirect to={{ pathname: '/' }} />
                    }} />
                  </Switch>
                </Content>
              </Layout>

              <Footer style={{ textAlign: 'center' }}>
                <FooterContent />
              </Footer>

            </Layout>

            
          </div>
        )}
      </ContainerQuery>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js